<template>
    <div class="layout-set">
        <div class="actions">
            <Select class="shadow112006" v-model="selected" style="width:150px" @on-change="selectChange">
                <Option v-for="item in workshops" :value="item.ws_id" :key="item.ws_id">{{ item.name }}</Option>
            </Select>
        </div>
        <!-- 绘图区域 -->
        <Row :gutter="15">
            <Col span="18" push="6">
                <Card :title="$t('a_draw')" :bordered="false" shadow style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25); overflow: auto;">
                    <v-stage ref="stage" :config="{width: shopW+1, height: shopH+1}">
                        <v-layer ref="layer">
                            <v-rect :config="{x:0.5,y:0.5,width:shopW,height:shopH,stroke:'black',strokeWidth:1,fill:'#ffffff'}"></v-rect>
                            <v-image :config="{x:0,y:0,width:shopW+0.5,height:shopH+0.5,image:bgImageObj,imgurl:bgImageUrl}"></v-image>
                            <v-group v-for="(item,index) in devicesCVS" :key="index" :config="item.attrs" @mouseenter="deviceMouseenterCVS" @mouseleave="deviceMouseleaveCVS" @dragmove="deviceDragmoveCVS" @dblclick="deviceDblclickCVS" @dragstart="deviceDragstartCVS">
                                <v-rect :config="item.children[0].attrs"></v-rect>
                                <v-group :config="item.children[1].attrs">
                                    <v-image :config="item.children[1].children[0].attrs"></v-image>
                                    <v-text :config="item.children[1].children[1].attrs"></v-text>
                                </v-group>
                            </v-group>
                        </v-layer>
                    </v-stage>
                </Card>
            </Col>
            <Col span="6" pull="18">
                <!-- 待处理区域 -->
                <Card class="layout-pending" :title="$t('a_toBeProcessed')" :bordered="false" shadow style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);margin-bottom:15px;" :key="10">
                    <p slot="extra">{{$t('a_deviceAllNum')}}： {{devices.length}}&nbsp;&nbsp;&nbsp;{{$t('a_pendingNum')}}： {{devices.length - dealDevicesId.length}}</p>
                    <Row :gutter="8">
                        <Col span="6" v-for="item in dealDevices" :key="item.gid" style="padding-bottom:8px;">
                            <div class="device" draggable="true" @mousemove="deviceMousemove($event,item.gid)">
                                <div>
                                    <img src="@/images/temporary/group.jpg" draggable="false" :ref="`${item.gid}`">
                                    <p>{{item.name}}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <!-- 说明区域 -->
                <Card :title="$t('a_description')" :bordered="false" shadow style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);">
                    <div class="layout-process">
                        <CellGroup>
                            <Cell :title="`I：${$t('a_description1')}`">
                                <div slot="label" class="process1">
                                    <InputNumber :max="1400" :min="limitShopMinW" :step="1" :precision="0" v-model="shopW" size="small"></InputNumber>&nbsp;*
                                    <InputNumber :max="800" :min="limitShopMinH" :step="1" :precision="0" v-model="shopH" size="small"></InputNumber>
                                </div>
                            </Cell>
                            <Cell :title="`II：${$t('a_description2')}`">
                                <Upload action slot="label" class="process2" :before-upload="uploadBGImage">
                                    <Button icon="ios-cloud-upload-outline" size="small" type="primary" style="width: 80px">{{$t('a_upload')}}</Button>
                                </Upload>
                            </Cell>
                            <Cell :title="`III：${$t('a_description3')}`"/>
                            <Cell :title="`IV：${$t('a_description4')}`">
                                <div slot="label" class="process4">
                                    <div class="position">
                                        <InputNumber :min="0" :step="1" :precision="0" v-model="deviceInfo.x" size="small" @on-change="changeData('x')"></InputNumber>&nbsp;*
                                        <InputNumber :min="0" :step="1" :precision="0" v-model="deviceInfo.y" size="small" @on-change="changeData('y')"></InputNumber>
                                    </div>
                                    <div class="devicesize">
                                        <InputNumber :min="0" :max="shopW" :step="1" :precision="0" v-model="deviceInfo.width" size="small" @on-change="changeData('width')"></InputNumber>&nbsp;*
                                        <InputNumber :min="0" :max="shopH" :step="1" :precision="0" v-model="deviceInfo.height" size="small" @on-change="changeData('height')"></InputNumber>
                                    </div>
                                </div>
                            </Cell>
                            <Cell :title="`V：${$t('a_description5')}`">
                                <div slot="label" class="process5">
                                    <Button size="small" type="primary" icon="md-trash" @click="deleteDevice" style="width: 80px" :disabled="changeDeviceCVS.length == 0">{{$t('delete')}}</Button>
                                </div>
                            </Cell>
                            <Cell :title="`VI：${$t('a_description6')}`">
                                <div slot="label" class="process6">
                                    <Button size="small" type="info" icon="md-refresh" @click="reset" style="width: 80px" :disabled="changeDeviceCVS.length != 0">{{$t('a_reset')}}</Button>
                                </div>
                            </Cell>
                            <Cell :title="`VII：${$t('a_description7')}`">
                                <div slot="label" class="process7">
                                    <Button size="small" type="info" icon="md-archive" @click="saveLayout" style="width: 80px" :disabled="changeDeviceCVS.length != 0">{{$t('a_save')}}</Button>
                                </div>
                            </Cell>
                        </CellGroup>
                        <div id="container1"></div>
                    </div>
                </Card>
            </Col>
        </Row>
        <LayoutFooter/>
    </div>
</template>
<script>
import LayoutFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
export default {
    components: { LayoutFooter },
    created() {
        this.$store.commit('upNavbar', 11);
    },
    mounted() {
        //获得所有的车间
        Axios.get(AxiosUrl.workshop.select, {
            params: {
                cid: this.$store.state.user.cid
            }
        }).then(res => {
            if (res.data.code == 200) {
                this.workshops = res.data.data;
                if (this.workshops.length) {
                    this.selected = this.workshops[0].ws_id;
                    this.sweepDvsAndLayout();
                }
            } else {
                console.log(res.data.msg);
            }
        });
        //stage对应dom元素的事件
        this.stage = this.$refs.stage.getNode();
        this.layer = this.$refs.layer.getNode();
        this.stage.getContainer().addEventListener('dragover', function(e) {
            e.preventDefault();
        });
        this.stage.getContainer().addEventListener('drop', e => {
            e.preventDefault();
            if (this.changeDeviceCVS.length != 0) return; //如果有编辑中的设备，那么不能拖动
            var clickDevice = {};
            var len = this.devices.length;
            for (let i = 0; i < len; i++) {
                if (this.devices[i].gid == this.clickDeviceId) {
                    clickDevice = this.devices[i];
                    break;
                }
            }
            var width = 100;
            var height = 100;
            //绘制块
            var groupObj = new Object({
                attrs: {
                    x: e.layerX - this.mouseP.X,
                    y: e.layerY - this.mouseP.Y,
                    width: width,
                    height: height,
                    name: `Group${this.clickDeviceId.toString()}`,
                    draggable: true
                },
                children: [
                    {
                        attrs: {
                            x: 0.5,
                            y: 0.5,
                            width: width,
                            height: height,
                            fill: '#898989',
                            cornerRadius: 4,
                            stroke: '#444',
                            strokeWidth: 1,
                            name: `Rect${this.clickDeviceId.toString()}`,
                            shadowColor: 'black',
                            shadowBlur: 10,
                            shadowOffset: { x: 5, y: 5 },
                            shadowEnabled: false
                        }
                    },
                    {
                        attrs: {
                            x: 0 + 1,
                            // y: height / 2,
                            y: 0 + 1,
                            width: width,
                            // height: height / 2,
                            // offsetY: height / 2 / 2,
                            name: `CGroup${this.clickDeviceId.toString()}`
                        },
                        children: [
                            {
                                attrs: {
                                    // x: width / 2,
                                    x: 0,
                                    y: 0,
                                    image: this.$refs[this.clickDeviceId][0],
                                    // offsetX: width / 3 / 2,
                                    width: width - 1,
                                    height: (height / 5) * 3,
                                    name: `Image${this.clickDeviceId.toString()}`,
                                    imgurl: this.$refs[this.clickDeviceId][0].src
                                }
                            },
                            {
                                attrs: {
                                    x: 0,
                                    y: 0 + (height / 5) * 3,
                                    width: width,
                                    height: (height / 5) * 2,
                                    text: clickDevice.name,
                                    fontSize: Math.floor(height / 8) < 12 ? 12 : Math.floor(height / 8),
                                    fontFamily: '微软雅黑',
                                    verticalAlign: 'top',
                                    fill: '#ffffff',
                                    align: 'center',
                                    name: `Text${this.clickDeviceId.toString()}`
                                }
                            }
                        ]
                    }
                ]
            });
            this.devicesCVS.push(groupObj);
            this.dealDevicesId.push(this.clickDeviceId);
            this.deviceInfo.x = groupObj.attrs.x;
            this.deviceInfo.y = groupObj.attrs.y;
            this.deviceInfo.width = groupObj.attrs.width;
            this.deviceInfo.height = groupObj.attrs.height;
            this.setLimitShop();
        });
    },
    data() {
        return {
            selected: 0, //选中的车间
            workshops: [], //所有车间列表
            /////////////////*待处理区数据*/////////////////
            devices: [], //选中车间的所有设备列表
            dealDevicesId: [], //所有已经处理的设备id
            clickDeviceId: 0, //点击的设备的gid
            deleteDeviceId: [], //所有已经删除的设备的id  在车间中删除，但是在布局图中还有，待删除的设备
            mouseP: {
                X: 0,
                Y: 0
            }, //要移动div时候，鼠标的位置
            /////////////////*步骤区数据*/////////////////
            shopW: 0,
            shopH: 0,
            limitShopMinW: 0, //区域的最小限制
            limitShopMinH: 0,
            deviceInfo: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            /////////////////*stage对象*/////////////////
            stage: {},
            layer: {},
            bgImageUrl: '', //背景图片
            devicesCVS: [], //所有设备的矩形框数组
            changeDeviceCVS: [], //所有双击过的矩形组对象，为了编辑位置和尺寸
            mouseDragstartP: {
                //拖拽开始的位置，每次拖拽都会更新
                X: 0,
                Y: 0
            },
            //多个元素同时拖拽时，记录下当前元素所能拖拽的范围
            limitPos: {
                minX: 0,
                maxX: 0,
                minY: 0,
                maxY: 0
            }
        };
    },
    methods: {
        //初始化画布
        initCanvas() {
            this.dealDevicesId = [];
            this.devicesCVS = [];
            this.shopW = 0;
            this.shopH = 0;
            this.limitShopMinW = 0;
            this.limitShopMinH = 0;
            this.bgImageUrl = '';
        },
        //获得车间下所有的机组
        getDevices() {
            return Axios.get(AxiosUrl.group.select, {
                params: {
                    cid: this.$store.state.user.cid,
                    ws_id: this.selected
                }
            });
        },
        //获得车间布局
        getLayout() {
            return Axios.get(AxiosUrl.workshop.layoutinfo, {
                params: {
                    ws_id: this.selected
                }
            });
        },
        //获得车间设备和车间布局后，进行处理
        sweepDvsAndLayout() {
            Axios.all([this.getDevices(), this.getLayout()]).then(
                Axios.spread((devs, layout) => {
                    // 两个请求现在都执行完成
                    if (devs.data.code == 200 && layout.data.code == 200) {
                        //待处理区
                        let devices = devs.data.data;
                        devices.forEach(item => {
                            item.top = Math.floor(Math.random() * 100) + 'px';
                            item.left = Math.floor(Math.random() * 170) + 16 + 'px';
                        });
                        this.devices = devices;
                        let allDevicesID = [];
                        //把所有的id提出来 用作后面判断是否是已经删除的设备
                        for (let { gid } of this.devices) {
                            allDevicesID.push(gid);
                        }
                        //假如有接口，获得接口中的数据然后进行处理
                        this.initCanvas();
                        let shopJSON = layout.data.data.layout;
                        if (shopJSON.length < 10) return;
                        shopJSON = JSON.parse(shopJSON);
                        this.shopW = shopJSON.attrs.width - 1;
                        this.shopH = shopJSON.attrs.height - 1;
                        //加载背景图
                        if (shopJSON.children[0].children[1].attrs.imgurl != '') {
                            this.bgImageUrl = shopJSON.children[0].children[1].attrs.imgurl;
                            var imageObj = new Image();
                            imageObj.src = this.bgImageUrl;
                            imageObj.onload = () => {
                                this.layer.children[1].image(imageObj);
                                this.layer.children[0].fill(null);
                            };
                        }
                        //加载设备块
                        this.dealDevicesId = [];
                        shopJSON.children[0].children.forEach(item => {
                            if (item.className == 'Group') {
                                this.devicesCVS.push(item);
                                var image = new Image();
                                image.src = item.children[1].children[0].attrs.imgurl;
                                image.onload = () => {
                                    let imageCVS = this.stage.find(`.${item.children[1].children[0].attrs.name}`)[0];
                                    imageCVS.image(image);
                                    this.setLimitShop();
                                };
                                let gid = Number(item.attrs.name.replace(/\D/g, ''));
                                if (allDevicesID.includes(gid)) {
                                    this.dealDevicesId.push(gid); //已经在图中的被视为已经处理过的
                                } else {
                                    this.deleteDeviceId.push(gid);
                                }
                            }
                        });
                    } else {
                        console.log(devs.data.msg);
                    }
                })
            );
        },
        //车间下拉列表变化时触发  选择车间
        selectChange(value) {
            this.sweepDvsAndLayout();
        },
        deviceMousemove(e, id) {
            this.mouseP.X = e.layerX;
            this.mouseP.Y = e.layerY;
            this.clickDeviceId = id;
        },
        ////////////////////////////////说明区功能/////////////////////////
        //上传图片
        uploadBGImage(file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = e => {
                this.bgImageUrl = reader.result;
            };
            return false;
        },
        //修改设备的尺寸和位置
        changeData(des) {
            if (this.changeDeviceCVS.length == 0) return;
            if (des == 'x') {
                for (let item of this.changeDeviceCVS) {
                    if (this.shopW - item.width() <= this.deviceInfo.x) continue;
                    item.x(this.deviceInfo.x);
                }
            } else if (des == 'y') {
                for (let item of this.changeDeviceCVS) {
                    if (this.shopH - item.height() <= this.deviceInfo.y) continue;
                    item.y(this.deviceInfo.y);
                }
            } else if (des == 'width') {
                this.changeDeviceCVS.forEach(item => {
                    var topGroup = item;
                    var rect = topGroup.children[0];
                    var group = topGroup.children[1];
                    var image = topGroup.children[1].children[0];
                    var text = topGroup.children[1].children[1];
                    var width = this.deviceInfo.width;

                    if (this.deviceInfo.width + topGroup.x() > this.shopW && this.deviceInfo.width > topGroup.width()) {
                        let d = -(this.deviceInfo.width - topGroup.width());
                        topGroup.move({
                            x: d,
                            y: 0
                        });
                    }

                    topGroup.width(width);
                    rect.width(width);
                    group.width(width);
                    // image.x(width / 2);
                    image.width(width - 1);
                    // image.offsetX(width / 3 / 2);
                    text.width(width);
                });
            } else {
                this.changeDeviceCVS.forEach(item => {
                    var topGroup = item;
                    var rect = topGroup.children[0];
                    var group = topGroup.children[1];
                    var image = topGroup.children[1].children[0];
                    var text = topGroup.children[1].children[1];
                    var height = this.deviceInfo.height;

                    if (this.deviceInfo.height + topGroup.y() > this.shopH && this.deviceInfo.height > topGroup.height()) {
                        let d = -(this.deviceInfo.height - topGroup.height());
                        topGroup.move({
                            x: 0,
                            y: d
                        });
                    }

                    topGroup.height(height);
                    rect.height(height);
                    // group.y(height / 2);
                    // group.height(height / 2);
                    // group.offsetY(height / 2 / 2);
                    image.height((height / 5) * 3);
                    text.y((height / 5) * 3);
                    text.height((height / 5) * 2);
                    var fontSize = Math.floor(height / 8) < 12 ? 12 : Math.floor(height / 8);
                    text.fontSize(fontSize);
                });
            }
            this.layer.draw();
            this.setLimitShop();
        },
        saveLayout() {
            const thumb = this.stage.toDataURL();
            const layout = this.stage.toJSON();
            Axios.post(
                AxiosUrl.workshop.layout,
                {
                    ws_id: this.selected,
                    layout,
                    thumb
                },
                {
                    transformRequest: [
                        function(data) {
                            let ret = '';
                            for (let it in data) {
                                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                            }
                            return ret;
                        }
                    ],
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            ).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('a_saveSuccess'));
                } else {
                    this.$Message.error(this.$t('a_savefail'));
                }
            });
        },
        deleteDevice() {
            let delDevice = [...this.changeDeviceCVS];
            delDevice.forEach((item, index) => {
                let id = Number(item.name().replace(/\D/g, ''));
                if (this.dealDevicesId.includes(id)) {
                    this.dealDevicesId.splice(index, 1);
                }
                item.destroy();
            });
            this.layer.draw();
            this.changeDeviceCVS = [];
        },
        reset() {
            this.initCanvas();
        },
        ////////////////////////////////绘图区功能/////////////////////////
        //每次移动位置，都要重新计算车间的最小极限尺寸，因为车间尺寸调整后，不能有设备在车间的外部
        setLimitShop() {
            this.limitShopMinW = 0;
            this.limitShopMinH = 0;
            for (let item of this.layer.children) {
                if (item.nodeType != 'Group') continue;
                let x = item.x() + item.width();
                let y = item.y() + item.height();
                if (x > this.limitShopMinW) this.limitShopMinW = x;
                if (y > this.limitShopMinH) this.limitShopMinH = y;
            }
        },
        //鼠标进入设备矩形块内
        deviceMouseenterCVS(e) {
            var len = this.changeDeviceCVS.length;
            if (len == 0) {
                document.body.style.cursor = 'move';
                this.deviceInfo.x = e.currentTarget.attrs.x;
                this.deviceInfo.y = e.currentTarget.attrs.y;
                this.deviceInfo.width = e.currentTarget.attrs.width;
                this.deviceInfo.height = e.currentTarget.attrs.height;
                //把当前矩形块置顶
                e.currentTarget.moveToTop(); //group.moveToTop()
                this.layer.draw();
            } else {
                this.deviceInfo.x = this.changeDeviceCVS[0].attrs.x;
                this.deviceInfo.y = this.changeDeviceCVS[0].attrs.y;
                this.deviceInfo.width = this.changeDeviceCVS[0].attrs.width;
                this.deviceInfo.height = this.changeDeviceCVS[0].attrs.height;
                for (let i = 0; i < len; i++) {
                    if (this.changeDeviceCVS[i].attrs.name == e.currentTarget.attrs.name) {
                        document.body.style.cursor = 'move';
                        e.currentTarget.moveToTop(); //group.moveToTop()
                        this.layer.draw();
                    }
                }
            }
        },
        //鼠标离开设备矩形块
        deviceMouseleaveCVS() {
            document.body.style.cursor = 'default';
            var len = this.changeDeviceCVS.length;
            if (len == 0) {
                this.deviceInfo.x = 0;
                this.deviceInfo.y = 0;
                this.deviceInfo.width = 0;
                this.deviceInfo.height = 0;
            }
        },
        //鼠标移动设备块
        deviceDragmoveCVS(e) {
            var len = this.changeDeviceCVS.length;
            if (len == 0) {
                let { x, y, width, height } = e.target.attrs;
                if (x < 0) {
                    e.target.x(0);
                    x = e.target.x();
                } else if (x >= this.shopW - width) {
                    e.target.x(this.shopW - width);
                    x = e.target.x();
                }
                if (y < 0) {
                    e.target.y(0);
                    y = e.target.y();
                } else if (y >= this.shopH - height) {
                    e.target.y(this.shopH - height);
                    y = e.target.y();
                }
                this.deviceInfo = { x, y, width, height };
            } else {
                let { x, y, width, height } = e.target.attrs;
                //先限制位置
                if (x <= this.limitPos.minX) {
                    e.target.x(this.limitPos.minX);
                    x = e.target.x();
                } else if (x >= this.limitPos.maxX) {
                    e.target.x(this.limitPos.maxX);
                    x = e.target.x();
                }
                if (y <= this.limitPos.minY) {
                    e.target.y(this.limitPos.minY);
                    y = e.target.y();
                } else if (y >= this.limitPos.maxY) {
                    e.target.y(this.limitPos.maxY);
                    y = e.target.y();
                }
                //修改上次记录的位置参数
                var diff = {
                    X: x - this.mouseDragstartP.X,
                    Y: y - this.mouseDragstartP.Y
                };
                this.changeDeviceCVS.forEach(item => {
                    if (item.attrs.name != e.target.attrs.name) {
                        item.x(item.x() + diff.X);
                        item.y(item.y() + diff.Y);
                    }
                });
                this.layer.draw();
                this.mouseDragstartP.X = x;
                this.mouseDragstartP.Y = y;
                this.deviceInfo.x = this.changeDeviceCVS[0].attrs.x;
                this.deviceInfo.y = this.changeDeviceCVS[0].attrs.y;
                this.deviceInfo.width = this.changeDeviceCVS[0].attrs.width;
                this.deviceInfo.height = this.changeDeviceCVS[0].attrs.height;
            }
            this.setLimitShop();
        },
        //双击设备块
        deviceDblclickCVS(e) {
            var current = e.currentTarget;
            var len = this.changeDeviceCVS.length;
            var isHaved = false;
            if (len == 0) {
                this.changeDeviceCVS.push(e.currentTarget);
                e.currentTarget.children[0].shadowEnabled(true);
                isHaved = true;
            } else {
                for (let i = 0; i < len; i++) {
                    if (this.changeDeviceCVS[i].attrs.name == current.attrs.name) {
                        this.changeDeviceCVS[i].children[0].shadowEnabled(false);
                        this.changeDeviceCVS.splice(i, 1);
                        isHaved = true;
                        break;
                    }
                }
            }
            //如果该设备没有则添加
            if (!isHaved) {
                this.changeDeviceCVS.push(e.currentTarget);
                e.currentTarget.children[0].shadowEnabled(true);
            }
            //如果编辑的设备，设置只有编辑状态中的设备可以被拖动，否则都可以被拖动
            if (this.changeDeviceCVS.length != 0) {
                this.layer.children.forEach(item => {
                    if (item.nodeType == 'Group') {
                        item.draggable(false);
                    }
                });
                this.changeDeviceCVS.forEach(item => {
                    item.draggable(true);
                });
            } else {
                this.layer.children.forEach(item => {
                    if (item.nodeType == 'Group') {
                        item.draggable(true);
                    }
                });
            }
            this.layer.draw();
        },
        //开始拖动时
        deviceDragstartCVS(e) {
            var len = this.changeDeviceCVS.length;
            if (len == 0) return;
            this.mouseDragstartP.X = e.target.x();
            this.mouseDragstartP.Y = e.target.y();
            //当前点击的设备自己拖动时，所能运动的范围
            let curLimitPos = {
                curMinX: 0,
                curMaxX: this.shopW - e.target.width(),
                curMinY: 0,
                curMaxY: this.shopH - e.target.height()
            };
            if (len > 1) {
                let left = this.shopW,
                    top = this.shopH,
                    right = 0,
                    bottom = 0;
                for (let item of this.changeDeviceCVS) {
                    let { x, y, width, height } = item.attrs;
                    if (x < left) left = x;
                    if (y < top) top = y;
                    if (x + width > right) right = x + width;
                    if (y + height > bottom) bottom = y + height;
                }
                curLimitPos.curMinX += e.target.x() - left;
                curLimitPos.curMaxX = e.target.x() + (this.shopW - right); //this.shopW - right 表示最右侧的块可以移动的px数量
                curLimitPos.curMinY += e.target.y() - top;
                curLimitPos.curMaxY = e.target.y() + (this.shopH - bottom);
            }
            let { curMinX: minX, curMaxX: maxX, curMinY: minY, curMaxY: maxY } = curLimitPos;
            this.limitPos = { minX, maxX, minY, maxY };
        }
    },
    computed: {
        //待处理区显示的设备（过滤）
        dealDevices() {
            return this.devices.filter(item => {
                return !this.dealDevicesId.includes(item.gid);
            });
        },
        //canvas背景图片的对象
        bgImageObj() {
            if (this.bgImageUrl == '') {
                return null;
            } else {
                var imageObj = new Image();
                imageObj.src = this.bgImageUrl;
                imageObj.onload = () => {
                    this.layer.children[1].image(imageObj);
                    this.layer.children[0].fill(null);
                    this.layer.draw();
                    return imageObj;
                };
            }
        }
    }
};
</script>
<style lang="less">
.layout-set {
    .layout-pending {
        .ivu-card-extra {
            top: 14px;
            right: 16px;
        }
        .ivu-card-body {
            height: 300px;
            overflow: auto;
        }
    }
    .device {
        // width: 100px;
        height: 100px;
        background-color: #898989;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;
        // border: 1px solid #333;
        box-shadow: 0 0 3px #222;
        cursor: move;
        div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            p {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .layout-process {
        margin: 0 -16px;
        .process4 {
            display: flex;
            // justify-content: space-between;
            .devicesize {
                padding-left: 10px;
            }
        }
        .ivu-cell-label {
            padding-left: 15px;
        }
        .ivu-cell-title {
            white-space: normal;
        }
    }
}
</style>






// WEBPACK FOOTER //
// src/views/system/layoutManage.vue